import { Row, Col, Container, Button, Modal } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import '../../auth/Style.css';
import SwiperCore, { Navigation, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import toast, { Toaster } from 'react-hot-toast';
import whatsapp from '../../../../assets/images/whatsapp.svg'
import pdf from '../../../../assets/images/pdf.png'
import { useEffect, useState } from 'react';
import { FaAngleRight, FaCaretRight } from 'react-icons/fa6';
import axios from 'axios';
import * as moment from 'moment';
import { FaMapMarkerAlt, FaPhoneAlt, FaFilePdf, FaShareAlt, FaDownload } from 'react-icons/fa';
import html2canvas from 'html2canvas';
import { useProjectName } from '../../../../Context/ProjectNameContext';


// install Swiper modules
SwiperCore.use([Navigation, Autoplay]);

const ScannedQrcDetails = () => {
   let navigate = useNavigate()
   const [contactModal, setContactModal] = useState(null);
   const [contactModalDetails, setContactModalDetails] = useState(null);
   const params = useParams();
   const [qrc, setQrc] = useState(null);
   const [contactData, setContactData] = useState(null);
   const [userLocation, setUserLocation] = useState({ latitude: null, longitude: null });
   const [error, setError] = useState(null);
   const [findUploadedConditionDocs, setFindUploadedConditionDocs] = useState([]);
const projectName = useProjectName();

   const getLocation = () => {
      if (navigator.geolocation) {
         navigator.geolocation.getCurrentPosition(
            (position) => {
               setUserLocation({
                  latitude: position.coords.latitude,
                  longitude: position.coords.longitude,
               });
               setError(null);
            },
            (error) => {
               setError(error.message);
            }
         );
      } else {
         setError('Geolocation is not supported by this browser.');
      }
   };
   const splitFileLink = (a) => {
      const x = a.split('_');
      const y = x[x.length - 1];
      return decodeURIComponent(y);
   }


   const handleGenerateQrc = async () => {
      // e.preventDefault();
      const scanId = new URLSearchParams(window.location.search).get("scanId");

      const dataToSent = {
        scanId:scanId,
        lat: userLocation?.latitude,
        lon: userLocation?.longitude
      }

      try {
         const response = await axios.post(
            `${process.env.REACT_APP_URL}/api/qrc/scan/${params?.qrcid}`, dataToSent,

         );
         // toast.success(response?.data?.message);
         setQrc(response?.data?.data?.qrcContentData);

      } catch (error) {
         toast.error(error?.response?.data?.message);
      }
   }
   useEffect(() => {
      getLocation();
      if (userLocation?.latitude) {
         handleGenerateQrc();
      }
   }, [!userLocation?.latitude])
   useEffect(() => {
      let a = qrc?.qrcContentId?.conditionIds?.filter(array => array?.conditionDocuments?.length > 0);
      setFindUploadedConditionDocs(a);
   }, [qrc])

   const hasDocumentLinks = qrc?.qrcContentId?.doctersAdviceDocLink ||
qrc?.qrcContentId?.doctersReportsLink ||
(qrc?.qrcContentId?.otherDocuments && qrc.qrcContentId.otherDocuments.length > 0);

const handleCallClick = (number) => {
   window.location.href = `tel:${number}`;
 };
 
 
 
 const handleShare = (url) => {
   if (navigator.share) {
     navigator.share({
       title: 'Shared Document',
       url: url,
     })
     .catch((error) => console.error('Error sharing', error));
   } else {
     alert('Sharing is not supported in your browser. Copy the link manually: ' + url);
   }
 };
 
 const handleDownload = (url) => {
   const link = document.createElement('a');
   link.href = url;
   link.setAttribute('download', 'file.pdf');
   document.body.appendChild(link);
   link.click();
   document.body.removeChild(link);
 };
 
 const handleDownloadMultiple = async (fileUrls) => {
   const downloadFile = (url) => {
     return fetch(url)
       .then(response => response.blob())
       .then(blob => {
         const link = document.createElement('a');
         link.href = URL.createObjectURL(blob);
         link.download = url.split('/').pop(); // Use the file name from the URL
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
       })
       .catch(error => {
         console.error('Error downloading file:', error);
       });
   };
 
   try {
     await Promise.all(fileUrls.map(fileUrl => downloadFile(fileUrl)));
   } catch (error) {
     console.error('Error in handleDownloadMultiple:', error);
   }
 };
 
 const downloadSectionAsImage = () => {
   const section = document.querySelector('.previewcontainer');
   html2canvas(section).then(canvas => {
     const link = document.createElement('a');
     link.href = canvas.toDataURL('image/png');
     link.download = 'section-image.png';
     link.click();
   });
 };
 
 const handleShareSectionAsImage = () => {
   const section = document.querySelector('.previewcontainer');
   
   html2canvas(section).then(canvas => {
     canvas.toBlob((blob) => {
       const file = new File([blob], "section-image.png", { type: "image/png" });
 
       if (navigator.canShare && navigator.canShare({ files: [file] })) {
         navigator.share({
           files: [file],
           title: 'Shared Section Image',
           text: 'Here is the section image.',
         }).catch((error) => console.error('Error sharing:', error));
       } else {
         alert('Sharing is not supported in your browser.');
       }
     });
   });
 };

   return (
      <>
         <section className="d-flex justify-content-center " >

            <Container className="p-0" style={{ alignItems: "center", display: "flex", flexDirection: "column", justifyContent: "center" }}>
               {/* <div style={{ fontSize: "30px", letterSpacing: "4px", color: "white", fontWeight: "600" }} className={window.innerWidth <= 768 ? "mobile-margin-top" : ""}>DIRIDO</div> */}

               <Row className="no-gutters w-100 px-1" style={{ borderRadius: "10px", justifyContent: "center", display: "flex", margin: "20px" }}>
                  {
                     qrc ?
                        <Col md="12" className=" d-flex flex-column justify-content-center " >
                                <div className="previewcontainer">
  <div className="previewhead">
    <span style={{textTransform:"uppercase"}}>DIRIDO</span>.com <span className="previewheadfree">try it for free</span>
  </div>
  <div className="previewscanned">
    You've scanned the CRITICAL D QRC CODE of
  </div>

  <div className="profile-card">
    <div className="profile-details">
      <div className="name-location">
      {qrc?.qrcContentId?.criticalUserProfileId?.name || 'N/A'} - {qrc?.qrcContentId?.criticalUserProfileId?.address?.state || 'N/A'} <FaMapMarkerAlt style={{ verticalAlign: 'middle' }} />
      </div>
      <div className="profile-info" style={{textAlign:"center"}}>
        <img src={qrc?.qrcContentId?.criticalUserProfileId?.profilePhotoLink || "./profile.png"} alt="Profile" className="profile-image" />
        <div className="details">
  <p><strong>Blood Group:</strong> {qrc?.qrcContentId?.criticalUserProfileId?.bloodType || 'N/A'}</p>
        <p>
  <strong>DOB:</strong> 
  {qrc?.qrcContentId?.criticalUserProfileId?.birthDate 
    ? moment(qrc.qrcContentId.criticalUserProfileId.birthDate).format('MMMM D, YYYY')
    : 'N/A'}
</p>         
          <p><strong>Email:</strong> {qrc?.qrcContentId?.criticalUserProfileId?.email1 || 'N/A'}</p>
          {/* <p><strong>Problem:</strong> Hypertension</p> */}
        </div>
      </div>
    </div>
  </div>

  <div className="additional-info">
  <div className="contact-alert">
      <p>Emergency contact - {qrc?.qrcContentId?.emergencyContactIds[0]?.firstName || 'N/A'} {qrc?.qrcContentId?.emergencyContactIds[0]?.lastName || 'N/A'}({qrc?.qrcContentId?.emergencyContactIds[0]?.mobile || 'N/A'})</p>
      <FaPhoneAlt size={20} style={{ verticalAlign: 'middle', marginLeft: '8px' }} onClick={() => handleCallClick(qrc?.qrcContentId?.emergencyContactIds[0]?.mobile || '')}/>
    </div>        
    <h1 className="waiting-help">Waiting for Help - Assist Me</h1>
    <h1 className="waiting-help">as i am advising here</h1>

    
    {/* <textarea className="advice-textarea" readOnly> */}
    <div style={{background:"#f9f9f9", border:"1px solid lightgray",padding:"10px", marginTop:"10px", borderRadius:"5px"}}>

    {qrc?.qrcContentId?.personalAdvice || 'N/A'}   
     </div>

    <h2 className="doctor-advice-heading">Doctor's Advice for Emergency Services</h2>
    
    {/* <textarea className="advice-textarea" readOnly> */}
    <div style={{background:"#f9f9f9", border:"1px solid lightgray",padding:"10px", marginTop:"10px", borderRadius:"5px"}}>

    {qrc?.qrcContentId?.doctersAdvice || 'N/A'}   
    </div>

    <h2 className="doctor-advice-heading">Category</h2>
    
    <div  style={{background:"#f9f9f9", border:"1px solid lightgray",padding:"10px", marginTop:"10px", borderRadius:"5px", }}>
    <p style={{ marginBottom: '5px', fontSize:"12px" }}><strong>Name : </strong> {qrc?.qrcContentId?.categoryId?.categoryName || 'N/A'}</p>
    <p style={{ marginBottom: '5px', fontSize:"12px" }}><strong>NamDescriptione : </strong> {qrc?.qrcContentId?.categoryId?.categoryDescription || 'N/A'}</p>
    </div>
    <h2 className="doctor-advice-heading">Condition's</h2>
    
    <div style={{background:"#f9f9f9", border:"1px solid lightgray",padding:"10px", marginTop:"10px", borderRadius:"5px"}}>
    {qrc?.qrcContentId?.conditionIds?.length > 0 ? (
                                    <ul style={{ paddingLeft: '20px', color: '#666' }}>
                                      {qrc?.qrcContentId?.conditionIds.map(condition => (
                                        <li key={condition?._id} style={{ marginBottom: '10px' }}>
                                          <p style={{ marginBottom: '5px', fontSize:"12px" }}><strong>Name : </strong> {condition?.conditionName}</p>
                                          <p style={{ marginBottom: '5px', fontSize:"12px" }}><strong>Description : </strong> {condition?.conditionDescription}</p>
                                        </li>
                                      ))}
                                    </ul>
                                  ) : (
                                    <p style={{ color: '#888' }}>No Conditions Available</p>
                                  )}
    </div>
  </div>
  <div className="report-card">
  {hasDocumentLinks &&(
    <div className="report-header">
      Download or share Doctor's report and advice
    </div>
  )}
    <div className="report-actions">
      <div className="pdf-section">
      {qrc?.qrcContentId?.doctersAdviceDocLink && (
      <div className="pdf-icon-container">
        <div>
          <FaShareAlt
            className="action-icon"
            onClick={() => handleShare(qrc.qrcContentId.doctersAdviceDocLink)}
          />
          <FaFilePdf size={38} className="pdf-icon" />
          <FaDownload
            className="action-icon"
            onClick={() => handleDownload(qrc.qrcContentId.doctersAdviceDocLink)}
          />
        </div>
        <p>Advice</p>
      </div>
    )}
    
    {qrc?.qrcContentId?.doctersReportsLink && (
      <div className="pdf-icon-container">
        <div>
          <FaShareAlt
            className="action-icon"
            onClick={() => handleShare(qrc.qrcContentId.doctersReportsLink)}
          />
          <FaFilePdf size={38} className="pdf-icon" />
          <FaDownload
            className="action-icon"
            onClick={() => handleDownload(qrc.qrcContentId.doctersReportsLink)}
          />
        </div>
        <p>Report</p>
      </div>
    )}

    {qrc?.qrcContentId?.otherDocuments?.length > 0 && (
      <div className="pdf-icon-container">
        <div>
          <FaShareAlt
            className="action-icon"
            onClick={() => handleDownloadMultiple(qrc.qrcContentId.otherDocuments.map(doc => doc.link))}
            />
          <FaFilePdf size={38} className="pdf-icon" />
          <FaDownload
            className="action-icon"
            onClick={() => handleDownloadMultiple(qrc.qrcContentId.otherDocuments.map(doc => doc.link))}
            />
        </div>
        <p>Other</p>
      </div>
    )}

      </div>
      <div className="share-download">
        <FaShareAlt size={18} className="action-icon" onClick={handleShareSectionAsImage}/>
        <h5>Download or share this page</h5>
        <FaDownload size={18} className="action-icon" onClick={downloadSectionAsImage}/>
      </div>
    </div>
  </div>

  <div className="health-card">
    <div className="health-message">
      <div>We wish you good health!</div>
    </div>
    <div className="powered-by">
      <div>Powered by {projectName}</div>
    </div>
  </div>

</div>
                        </Col>
                        :
                        <div style={{ height: "100vh" }} className='justify-content-center align-items-center d-flex'>
                           <div id='orderLoading'></div>
                        </div>
                  }
               </Row>
            </Container>
         </section >
         <Toaster position="top-right" reverseOrder={false}/>
         </>
   )
}

export default ScannedQrcDetails
   